import React from "react";
import { withStyles } from "@material-ui/styles";
import TextField from "@material-ui/core/TextField";

const styles = {
	root: {
		"& label.Mui-focused": {
			color: "#d84c93",
			"&:active": {
				color: "#d84c93",
			},
		},
	},
};

function TextFieldWithStyle(props) {
	return (
		<TextField className={props.classes.root} style={props.style} {...props}>
			{props.children}
		</TextField>
	);
}

export default withStyles(styles)(TextFieldWithStyle);
